"use client"

import { SaleChannelFeaturedCollection } from "@/types/sales-channel"
import { ProductCollectionCard } from "./ProductCollectionCard"
import { cn } from "@/lib/utils"
import { useTranslate } from "@tolgee/react"

export function FeaturedCollections(
  {
    collections,
    className,
    locale
  }: {
    collections: SaleChannelFeaturedCollection[]
    className?: string
    locale?: string
  }
) {

  const { t } = useTranslate()

  if (collections.length === 0) {
    return null
  }

  return (
    <section className={cn("relative mx-auto w-full py-12", className)}>
      <div className="mx-auto w-full">
        <div className="mb-12 text-center">
          <h2 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
            {t('home_featured_collections.heading')}
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">{t('home_featured_collections.subtitle')}</p>
        </div>

        <div className="grid grid-cols-2 gap-8">
              {collections.map((collection, index) => (
                <div key={collection.handle} className="aspect-[4/3] w-full">
                  <ProductCollectionCard
                    collection={collection}
                    priority={index < 2}
                    className="h-full" />
                </div>
              ))}
            </div>
      </div>
    </section>
  )
}
